import { NegativeColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      marginTop: Spacings.s16,
      padding: [Spacings.s72, Spacings.s0, Spacings.s72],

      [mediaQuery(1023)]: {
        marginTop: Spacings.s4,
        padding: [Spacings.s72, Spacings.s0, Spacings.s32],
      },
      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        marginTop: Spacings.s0,
        padding: [Spacings.s56, Spacings.s0, Spacings.s32],
      },
    },

    title: {
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
      maxWidth: 856,
      margin: [Spacings.s0, 'auto', Spacings.s72],
      fontSize: Spacings.s32,
      fontWeight: FontWeights.semibold,
      textAlign: 'center',
      lineHeight: LineHeights.l36,
      color: TextColors.tint1,
      overflow: 'hidden',

      [mediaQuery(1023)]: {
        '-webkit-line-clamp': 4,
        marginBottom: Spacings.s56,
        maxWidth: 456,
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        '-webkit-line-clamp': 5,
        marginBottom: Spacings.s32,
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l32,
      },
    },
    titleSkeleton: {
      maxWidth: 856,
      margin: [Spacings.s0, 'auto', Spacings.s72],
      height: 64,
    },

    dotsContainer: {
      margin: [Spacings.s0, 'auto'],
      '&.dot > li': {
        margin: [Spacings.s0, Spacings.s12],
        width: 12,
        height: 12,
        [mediaQuery(1023)]: {
          margin: [Spacings.s48, Spacings.s8, Spacings.s0],
        },
        '&.active': {
          margin: [Spacings.s0, Spacings.s12, Spacings.s0, Spacings.s12],
          width: 12,
          height: 12,
          backgroundColor: NegativeColors.base.action,
          [mediaQuery(1023)]: {
            margin: [Spacings.s48, Spacings.s8, Spacings.s0],
          },
          // [mediaQuery(766)]: {
          '@media screen and (max-width: 766px)': {
            width: 8,
            height: 8,
          },
        },
        // [mediaQuery(766)]: {
        '@media screen and (max-width: 766px)': {
          width: 8,
          height: 8,
        },
      },
    },
  }),
  {
    name: 'carousel-content',
  },
);

export default useStyles;
